/** Parse optional JSON text field for health sync payload editing. */
export function parseOptionalJsonField(
  raw: unknown,
): { ok: true; value: Record<string, unknown> | null } | { ok: false; error: string } {
  if (raw == null || raw === '') {
    return { ok: true, value: null };
  }
  if (typeof raw !== 'string') {
    return { ok: false, error: 'Payload must be a JSON string' };
  }
  try {
    const parsed = JSON.parse(raw);
    if (parsed !== null && typeof parsed !== 'object') {
      return { ok: false, error: 'Payload must be a JSON object' };
    }
    return { ok: true, value: parsed as Record<string, unknown> | null };
  } catch {
    return { ok: false, error: 'Invalid JSON in payload field' };
  }
}
